import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import LoaderUI from '../../../../components/common/loader'
import FileChart from './FileChart';
import './index.scss';
const FileTabs = ({ packetsCount, documentsCount, documentsGraphData, totalEditedFilesInGraph, pieChartData, _handleFileOptionClick, _handleBacklogOptionClick, barGraphOptions, pieChartOptions, editedDocumentCount, _handleEditFileOptionClick, isLoading, editedDocumentsInGraph}) => {
	const [activeTab, setActiveTab] = useState('1');

	const toggle = tab => {
		if (activeTab !== tab) setActiveTab(tab);
	}
	return (
		<div className='file-tab-wrapper d-flex position-relative'>
			{isLoading ? <LoaderUI FullWindow={false} inContainer className='tab-content-loader' /> 
			 : <>
			 <Nav tabs>
				<NavItem className={`${activeTab === '1' ? 'active' : ''}`} onClick={() => { toggle('1'); }}>
					<NavLink
						className={{ active: activeTab === '1' }}
					>
						<div className="tab-item">
							<h2>
								Total Documents
							</h2>
							<div className="inner d-flex align-items-center">
								<label>
									{documentsCount}
								</label>
								<div className="chart flex-fill">
									<img className='img-fluid' src={require('../../../../assets/img/line-graph.svg')} alt='Line Graph' />
								</div>
							</div>
						</div>
					</NavLink>
				</NavItem>
				<NavItem className={`${activeTab === '2' ? 'active' : ''}`} onClick={() => { toggle('2'); }}>
					<NavLink
						className={{ active: activeTab === '2' }}
					>
						<div className="tab-item">
							<h2>
								Total Edits
							</h2>
							<div className="inner d-flex">
								<label>
									{editedDocumentCount}
								</label>
								<div className="chart flex-fill">
									<img className='img-fluid' src={require('../../../../assets/img/line-graph.svg')} alt='Line Graph' />
								</div>
							</div>
						</div>
					</NavLink>
				</NavItem>
				<NavItem className={`${activeTab === '3' ? 'active' : ''}`} onClick={() => { toggle('3'); }}>
					<NavLink
						className={{ active: activeTab === '3' }}
					>
						<div className="tab-item">
							<h2>
								Total Packets
							</h2>
							<div className="inner d-flex">
								<label>
									{packetsCount}
								</label>
								<div className="chart flex-fill">
									<img className='img-fluid' src={require('../../../../assets/img/line-graph.svg')} alt='Line Graph' />
								</div>
							</div>
						</div>
					</NavLink>
				</NavItem>
			</Nav>
			<TabContent className='flex-fill' activeTab={activeTab}>
				{/* <LoaderUI message FullWindow={false} className='tab-content-loader' /> */}
				<TabPane tabId="1">
					<FileChart barColor={'#66e0e0'} data={documentsGraphData} headingLabel={'Total Documents Uploaded'} pie={false} barGraphOptions={barGraphOptions} handleClick={_handleFileOptionClick} />
				</TabPane>
				<TabPane tabId="2">
					{<FileChart barColor={'#f081aa'} 
					data={editedDocumentsInGraph}
					 headingLabel={'Total Edits'} pie={false} 
					 barGraphOptions={barGraphOptions} 
					 handleClick={_handleEditFileOptionClick} />}
				</TabPane>
				<TabPane tabId="3" >
					{/* <FileChart piedata={pieChartData} headingLabel={'Total Packets Uploaded'} pie={true} pieChartOptions={pieChartOptions} handleClick={_handleBacklogOptionClick} /> */}
					<FileChart barColor={'#66e0e0'} 
					data={pieChartData}
					  headingLabel={'Total Packets Uploaded'}
					   pie={false} barGraphOptions={pieChartOptions} 
					   handleClick={_handleBacklogOptionClick} />

					{/* <DonutChart data={data.donutdata}/> */}
				</TabPane>
			</TabContent>
		    </>}
		</div>
	);
}

export default FileTabs;
